import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import cn from 'classnames';
import * as React from 'react';

import s from './NavigateButton.module.scss';

export enum NavigationButtonDir {
  left = 'left',
  right = 'right',
}

type Props = {
  dir?: NavigationButtonDir;
  onClick?: VoidFunction;
  className?: string;
};

const arrowComponent = {
  [NavigationButtonDir.left]: ArrowLeftOutlined,
  [NavigationButtonDir.right]: ArrowRightOutlined,
};

const NavigationButton = React.forwardRef<HTMLElement, Props>(
  ({ dir = NavigationButtonDir.left, onClick, className }, ref) => {
    const Component = arrowComponent[dir];

    return (
      <Button
        onClick={onClick}
        className={cn(s['navigate-button'], className)}
        ref={ref}
      >
        <Component />
      </Button>
    );
  }
);

export default React.memo(NavigationButton);
